import DialogLayout from '../dialog-layout/dialog-layout';
import styles from './index.module.scss';

interface dialogProps {
  show: boolean;
  title: string;
  message: string;
}

const Dialog = ({ show, title, message }: dialogProps) => {
  const messageContent = () => {
    if (
      typeof message === 'string' &&
      (message.includes('\r') || message.includes('\n'))
    ) {
      return (
        <div
          dangerouslySetInnerHTML={{
            __html: message.replace(/(?:\r\n|\r|\n)/g, '<br>'),
          }}
        />
      );
    }
    return message;
  };

  return (
    <DialogLayout show={show}>
      <div className={styles.dialog}>
        <div className={styles.title}>{title}</div>
        <div className={styles.message}>{messageContent()}</div>
      </div>
    </DialogLayout>
  );
};

export default Dialog;
